export const UPLOAD_CSV_REQUEST = 'UPLOAD_CSV_REQUEST';
export const UPLOAD_CSV_SUCCESS = 'UPLOAD_CSV_SUCCESS';
export const UPLOAD_CSV_ERROR = 'UPLOAD_CSV_ERROR';
export const GET_CSV_REQUEST = 'GET_CSV_REQUEST';
export const GET_CSV_SUCCESS = 'GET_CSV_SUCCESS';
export const GET_CSV_ERROR = 'GET_CSV_ERROR';
export const SAVE_CSV_REQUEST = 'SAVE_CSV_REQUEST';
export const SAVE_CSV_SUCCESS = 'SAVE_CSV_SUCCESS';
export const SAVE_CSV_ERROR = 'SAVE_CSV_ERROR';
export const CLEAR_CSV = 'CLEAR_CSV';
export const CANCEL_UPLOAD_CSV = 'CANCEL_UPLOAD_CSV';
export const CANCEL_SAVE_CSV = 'CANCEL_SAVE_CSV';
